import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=6e8c3cae"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8c3cae')) {
      api.createRecord('6e8c3cae', component.options)
    } else {
      api.reload('6e8c3cae', component.options)
    }
    module.hot.accept("./Stack.vue?vue&type=template&id=6e8c3cae", function () {
      api.rerender('6e8c3cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/common/Stack.vue"
export default component.exports